// Scrolltrigger animation

gsap.registerPlugin(ScrollTrigger);


// フェードイン
gsap.utils.toArray(".js_fadein").forEach(target => {
  gsap.fromTo(target, {
    autoAlpha: 0,
  }, {
    autoAlpha: 1,
    scrollTrigger: {
      trigger: target,
      start: "top 70%",
      toggleActions: "play none none reset",
    },
  });
});

// フェードイン 遅め
gsap.utils.toArray(".js_fadein_slow").forEach(target => {
  gsap.fromTo(target, 1.0, {
    autoAlpha: 0,
  }, {
    autoAlpha: 1,
    scrollTrigger: {
      trigger: target,
      start: "top 70%",
      toggleActions: "play none none reset",
    },
  });
});


// フェードアップ
gsap.utils.toArray(".js_up").forEach(target => {
  gsap.fromTo(target, {
    autoAlpha: 0,
	y: 50,
  }, {
    autoAlpha: 1,
	y: 0,
    scrollTrigger: {
      trigger: target,
      start: "top 70%",
      toggleActions: "play none none reset",
    },
  });
});


// フェードダウン
gsap.utils.toArray(".js_down").forEach(target => {
  gsap.fromTo(target, {
    autoAlpha: 0,
	y: -50,
  }, {
    autoAlpha: 1,
	y: 0,
    scrollTrigger: {
      trigger: target,
      start: "top 70%",
      toggleActions: "play none none reset",
    },
  });
});


// 左から右へフェードイン
gsap.utils.toArray(".js_left").forEach(target => {
  gsap.fromTo(target, {
    autoAlpha: 0,
	x: -50,
  }, {
    autoAlpha: 1,
	x: 0,
    scrollTrigger: {
      trigger: target,
      start: "top 70%",
      toggleActions: "play none none reset",
    },
  });
});

// 右から左へフェードイン
gsap.utils.toArray(".js_right").forEach(target => {
  gsap.fromTo(target, {
    autoAlpha: 0,
	x: 50,
  }, {
    autoAlpha: 1,
	x: 0,
    scrollTrigger: {
      trigger: target,
      start: "top 70%",
      toggleActions: "play none none reset",
    },
  });
});


// オブジェクト パララックス
const items = gsap.utils.toArray(".objPala");

// 各要素に対してアニメーションを設定
items.forEach((item) => {
  gsap.fromTo(
    item, // アニメーションを適用する画像要素を取得
    {
      yPercent: 50, // パララックス前の要素の位置
			opacity: 0,
    },
    {
      yPercent: -20, // 上に要素の幅の1/5分移動
			opacity: 1,
      ease: "power2.out", // イージングなし
      scrollTrigger: {
        trigger: item, // アニメーションのトリガー要素
        start: "top bottom", // アニメーション開始位置
        scrub: 1, // 動作を遅らせる
      },
    }
  );
});

